import { z } from 'zod/v4';

export const regionDetailsSchema = z.object({
  description: z.string(),
  isEnabled: z.boolean(),
  mapsetId: z.number(),
  name: z.string(),
});

export type RegionDetails = z.infer<typeof regionDetailsSchema>;
